module.exports = __webpack_public_path__ + "static/media/biohub_middle.4b5c58a4.png";